import { render, staticRenderFns } from "./DiagnoseImageManage.vue?vue&type=template&id=20799dbc&"
import script from "./DiagnoseImageManage.vue?vue&type=script&lang=js&"
export * from "./DiagnoseImageManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports